<template>
  <customer-tracking-logs
    :show-skeleton="isLoading"
    :customer-tracking-logs="customerTrackingLogs"
  />
</template>

<script>
import CustomerTrackingLogs from '@/components/customer/CustomerTrackingLogs';

export default {
  components: {
    CustomerTrackingLogs,
  },
  props: {
    tab: {
      type: String,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      customerTrackingLogs: [],
    };
  },
  methods: {
    getCustomerTrackingLogs() {
      this.isLoading = true;
      this.axios.get(`customers_tracking/${this.customer.id}/logs`)
        .then(({ data }) => {
          this.$set(this, 'customerTrackingLogs', data);
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    tab(value) {
      if (value === 'tab-6') {
        this.getCustomerTrackingLogs();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/CustomerTrackingLogsTab.vue